import { ticketType } from "types";

export const performance2ticket = (products) => {
  const tickets: ticketType[] = [];
  let productsFinal: any[] = [];

  if (Array.isArray(products)) {
    productsFinal = products;
  } else {
    productsFinal.push(products);
  }

  productsFinal.map((product) => {
    let ticket: ticketType = {
      category: product.WARNING.ACCOUNT.DMGAK?._text ?? "",
      id: product.AK._text,
      ak: product.AK._text,
      code: product.CODE._text,
      sheetname: product.SHEETNAME._text,
      type: product.NAME._text,
      name: product.NAME._text,
      description: product.DESCRIPTION._text,
      price: parseFloat(product.PRICE.GROSS._text),
      num: 0,
      details: [],
    };

    tickets.push(ticket);
  });

  return tickets;
};

export const getEventName = (products) => {
  if (Array.isArray(products)) return products[0].SHEETNAME._text;

  return products.SHEETNAME._text;
};

export const performanceNotRequired = (products) => {
  if (Array.isArray(products))
    return products.every((product) => product.WARNING.PERFORMANCE.REQUIRED._text === "false");

  return products.WARNING.PERFORMANCE.REQUIRED._text === "false";
};
